import React, { Component } from 'react';
import "./VideoBg.scss";

class VideoBg extends Component {
    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
    }

    componentDidMount = () => {
        this.videoRef.current.play();
    }

    render = () => {
        const { source } = this.props
        return (
            <div className="video_bg">
                {
                    source && 
                    <video id="video" ref={this.videoRef} loop>
                        <source src={source} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                }

                { !source && <p>Informe o parâmetro 'source'</p>}
            </div>
        );
    }
}

export { VideoBg };